import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataGridColumnDefinition } from 'components';
import { AppConfigArea, AppConfigKey, FilterDefinitionType } from 'enums';
import { useShopIntegrationTypesConfig } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { AppConfig, AppConfigFilters, FilterDefinition } from 'types';
import { appConfigUtils } from 'utils';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const ShopsCommonTab: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const { availableShopIntegrationTypes } = useShopIntegrationTypesConfig();

  const additionalColumns = useMemo(
    (): DataGridColumnDefinition<AppConfig>[] => [
      {
        header: t('fields.shop_integration_type'),
        valueKey: 'shopIntegrationType',
        valueFormatter: appConfigUtils.getShopIntegrationTypeLabel,
      },
    ],
    [t],
  );

  const additionalFilters: FilterDefinition<AppConfigFilters>[] = useMemo(
    () => [
      {
        label: t('fields.shop_integration_type'),
        name: 'shopIntegrationType',
        type: FilterDefinitionType.Select,
        options: availableShopIntegrationTypes.map((type) => ({
          value: type,
          label: appConfigUtils.getShopIntegrationTypeLabel(type),
        })),
        getDisplayName: appConfigUtils.getShopIntegrationTypeLabel,
      },
      {
        label: t('fields.key'),
        name: 'key',
        type: FilterDefinitionType.Enum,
        enum: [
          AppConfigKey.BanksMap,
          AppConfigKey.PaymentTypeMap,
          AppConfigKey.DefaultMaxParallelCustomerOrders,
        ],
        getDisplayName: appConfigUtils.getKeyLabel,
      },
    ],
    [t, availableShopIntegrationTypes],
  );

  return (
    <ConfigsPageTab
      area={AppConfigArea.ShopsCommon}
      additionalColumns={additionalColumns}
      additionalFilters={additionalFilters}
    />
  );
};
